export function format12h(timeStr) {
  // If missing, null, undefined, empty, invalid → return placeholder
  if (!timeStr || typeof timeStr !== "string" || !timeStr.includes(":")) {
    return "--";
  }

  const parts = timeStr.split(":");
  if (parts.length < 2) return "--";

  const [hRaw, mRaw] = parts;
  const h = Number(hRaw);
  const m = Number(mRaw);

  // If hours or minutes are not valid numbers → return placeholder
  if (isNaN(h) || isNaN(m)) return "--";

  const date = new Date();
  date.setHours(h, m, 0, 0);

  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function todayMMDDYY() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}
export function tomorrowMMDDYY() {
  const d = new Date();
  const tomorrow1 = new Date(d);
  tomorrow1.setDate(tomorrow1.getDate() + 1);
  // console.log(tomorrow1);
  const dd = String(tomorrow1.getDate()).padStart(2, "0");
  // console.log(dd);
  const mm = String(tomorrow1.getMonth() + 1).padStart(2, "0");
  const yy = String(tomorrow1.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}

export function weekday() {
  return new Date().toLocaleDateString(undefined, { weekday: "long" });
}

export function compareTime(a, b) {
  // Turn each string into a Date object
  if (a === b) {
    return true;
  } else {
    return false;
  }
}

export function todayPretty() {
  return new Date().toLocaleDateString(undefined, {
    weekday: "long", // adds the full weekday name
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function tomorrowPretty() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toLocaleDateString(undefined, {
    weekday: "long", // adds the full weekday name
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function nowPretty() {
  return new Date().toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

export function hijriTodayEnglish() {
  try {
    const fmt = new Intl.DateTimeFormat("en-u-ca-islamic", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return fmt.format(new Date());
  } catch {
    return "Hijri date unavailable";
  }
}

export function scheduleMidnightReload() {
  setInterval(() => {
    const d = new Date();
    if (d.getHours() === 0 && d.getMinutes() === 2 && d.getSeconds() === 0) {
      window.location.reload();
    }
  }, 1000);
}
